// @ts-nocheck

export const localeCodes =  []
export const localeLoaders = {}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]
export const normalizedLocales = []

